import { Directive, Injector, Optional } from '@angular/core';

import {
  DISPLAY_TYPE,
  IWidgetConfig,
  StylableComponent,
  provideAsWidgetRef,
  Parent,
  styler,
  register
} from "@wm/components-base";

const DEFAULT_CLS = 'app-marquee app-container';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-marquee',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: '[wmMarquee]',
  providers: [
  provideAsWidgetRef(MarqueeDirective)
  ],
  standalone: true,
  exportAs: 'wmMarquee'
})
export class MarqueeDirective extends StylableComponent {
  static initializeProps = register('wm-marquee');

  constructor(inj: Injector, @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this);
  }
}

